// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3CjBb","content":"Consent_content__3F9iI","footer":"Consent_footer__1E4ic"};